import { TransformPlainObject } from './transform.plainObject';

export class UnionPlainObject extends TransformPlainObject {
}
